import { render } from "./cameraDetector.vue?vue&type=template&id=c6de85f8&scoped=true"
import script from "./cameraDetector.vue?vue&type=script&lang=js"
export * from "./cameraDetector.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=c6de85f8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\wjlfi\\Desktop\\1v1vue3\\demos\\basic\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6de85f8"]])

export default __exports__